import { render, staticRenderFns } from "./TaskInformation.vue?vue&type=template&id=ab6c2b84&scoped=true&"
import script from "./TaskInformation.vue?vue&type=script&lang=ts&"
export * from "./TaskInformation.vue?vue&type=script&lang=ts&"
import style0 from "./TaskInformation.vue?vue&type=style&index=0&id=ab6c2b84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab6c2b84",
  null
  
)

export default component.exports